import newAxios from "./newHttp";

export const getClassify = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/classify/treeData", data);
export const getClassifyDetails = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/article/list", data);
export const getArticle = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/articleDetails/" + data);
export const getCulture = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/media/list", data);
export const getTagList = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/tag/list", data);
export const getvideoList = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/mediaDetails/" + data);
export const getConsult = data =>
  newAxios.post(IPCONFIG + "/cms/open/api/potentialCustomers/add", data); //咨询
export const getPostType = data =>
  newAxios.get(IPCONFIG + `/cms/open/api/job/getJobCategory`,data); //岗位类型
export const getLocation = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/job/getWorkPlace", data); //工作地点
export const getPostList = data =>
  newAxios.get(IPCONFIG + "/cms/open/api/job/list", data); //岗位招聘列表 /cms/open/api/job/{jobId}
  export const getJobDetails = data =>   
  newAxios.get(IPCONFIG + `/cms/open/api/job/${data}`);//招聘详情
  export const getJobAdd = (data,headers) =>   
  newAxios.post(IPCONFIG + `/cms/open/api/job/resume/add`,data,headers);
  export const getFriendshipLink = (data) =>   
  newAxios.get(IPCONFIG + `/cms/open/api/blogroll/list`,data);//招聘详情 

  export const downloadPDF = (data) =>   
  newAxios.post(IPCONFIG + `/cms/open/api/customersDownload/add`,data);//下载pdf 

  export const getLocaltion = (data) =>   
  newAxios.get(IPCONFIG + `/cms/open/api/localtion/list`,data);//下载pdf 


// WEBPACK FOOTER //
// ./src/api/index.js